import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-266b0538"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-2 mb-2 text-xs text-neutral50",
  "data-testid": "sheet-mirror-coverage"
}
const _hoisted_2 = { class: "h-1.5 w-28 rounded-full bg-lightGray30 overflow-hidden" }
const _hoisted_3 = { class: "border border-lightGray30 rounded-lg overflow-x-auto bg-white" }
const _hoisted_4 = { class: "w-full text-sm text-left border-collapse" }
const _hoisted_5 = { class: "bg-gray-100 text-[11px] uppercase tracking-wide text-neutral50" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-2 w-10 font-bold" }, "#", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-2 w-20 font-bold" }, "Plantão", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-2 w-40 font-bold" }, "Estado da linha", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "py-2 px-2 w-16 font-bold",
  "aria-label": "Ações da linha"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-2 font-bold" }, "Médico", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-2 w-32 font-bold" }, "CRM", -1))
const _hoisted_12 = { class: "py-2 px-2 w-28 font-bold" }
const _hoisted_13 = ["data-testid"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-2 w-28 font-bold text-center" }, "Página da Folha", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-2 w-12" }, null, -1))
const _hoisted_16 = ["data-testid", "onClick", "onFocusin"]
const _hoisted_17 = { class: "py-1.5 px-2 text-xs text-neutral50 align-middle" }
const _hoisted_18 = ["data-testid"]
const _hoisted_19 = { class: "py-1.5 px-2 align-middle" }
const _hoisted_20 = ["data-testid"]
const _hoisted_21 = { class: "py-1.5 px-2 align-middle" }
const _hoisted_22 = { class: "flex items-center justify-center gap-1" }
const _hoisted_23 = ["aria-label", "disabled", "data-testid", "onClick"]
const _hoisted_24 = ["aria-label", "disabled", "data-testid", "onClick"]
const _hoisted_25 = ["aria-label", "disabled", "data-testid", "onClick"]
const _hoisted_26 = { class: "py-1.5 px-2 align-middle" }
const _hoisted_27 = ["title", "data-testid"]
const _hoisted_28 = ["value", "data-testid", "onInput"]
const _hoisted_29 = { class: "py-1.5 px-2 align-middle" }
const _hoisted_30 = ["data-testid"]
const _hoisted_31 = ["value", "data-testid", "onInput"]
const _hoisted_32 = { class: "py-1.5 px-2 align-middle" }
const _hoisted_33 = ["value", "disabled", "aria-label", "data-testid", "onChange"]
const _hoisted_34 = ["data-testid"]
const _hoisted_35 = {
  key: 0,
  class: "py-1.5 px-2 align-middle text-center"
}
const _hoisted_36 = ["checked", "disabled", "aria-label", "data-testid", "onChange"]
const _hoisted_37 = { class: "py-1.5 px-2 align-middle text-center whitespace-nowrap" }
const _hoisted_38 = ["disabled", "title", "aria-label", "data-testid", "onClick"]
const _hoisted_39 = ["disabled", "title", "aria-label", "data-testid", "onClick"]
const _hoisted_40 = { class: "py-1.5 px-2 align-middle text-center relative" }
const _hoisted_41 = ["aria-label", "aria-expanded", "data-testid", "disabled", "onClick"]
const _hoisted_42 = {
  key: 1,
  class: "inline-block h-6 w-6",
  "aria-hidden": "true"
}
const _hoisted_43 = ["data-testid"]
const _hoisted_44 = ["data-testid", "onClick"]
const _hoisted_45 = ["data-testid", "onClick"]
const _hoisted_46 = ["data-testid"]
const _hoisted_47 = { class: "px-3 pt-2 text-xs font-bold text-textPrimary" }
const _hoisted_48 = { class: "px-3 text-[10px] text-neutral50" }
const _hoisted_49 = { class: "px-3 py-2" }
const _hoisted_50 = ["data-testid"]
const _hoisted_51 = { class: "max-h-56 overflow-y-auto px-2 pb-1" }
const _hoisted_52 = ["data-testid", "onClick"]
const _hoisted_53 = { class: "min-w-0 flex-1" }
const _hoisted_54 = { class: "block text-xs font-bold truncate" }
const _hoisted_55 = { class: "block text-[10px] text-neutral50 font-mono" }
const _hoisted_56 = ["data-testid"]
const _hoisted_57 = {
  key: 0,
  class: "px-2 py-2 text-[11px] text-neutral50",
  "data-testid": "sheet-mirror-candidates-empty"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-3 pb-2 text-[10px] text-neutral50" }, " A escala oficial não muda: a substituição vale apenas para esta linha da folha. ", -1))
const _hoisted_59 = { class: "mt-2 flex flex-wrap items-center gap-2" }
const _hoisted_60 = { class: "ml-auto flex flex-wrap items-center gap-2 text-[10px]" }
const _hoisted_61 = ["data-testid"]

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { mdiAccountOffOutline, mdiAccountSwitchOutline, mdiUndoVariant } from '@mdi/js'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import {
  JOURNEY_EMPTY_CLASSES,
  focusFirstEmptyInput,
  focusFirstEmptyJourneyField,
  handleJourneyTab,
  isJourneyValueEmpty,
  journeyFieldAttrs
} from '@/utils/journey-focus'
import DoctorSuggestionCell from './DoctorSuggestionCell.vue'
import { formatCrm } from '../utils/crm-format'
import type { DSAttendanceDoctorSuggestion } from '@/Network/Types/Responses/DsAttendancePolicyResponses'
import { PrefillOutcome, PREFILL_OUTCOME_CHIP_LABELS } from '@/constants/ds-attendance.constants'
import {
  buildReplacementCandidates,
  isAutomaticallyConciliated,
  prefillCoverage,
  prefillCoverageLabel,
  resolveRowState,
  rowStateChipLabel,
  tallyOutcomes,
  type MirrorRow
} from '../utils/prefill-mirror'
import { formatPageCell, isValidPage, resolveRowPage } from '../utils/sheet-page-map'
import PaymentEligibilitySeal from '@/components/PaymentEligibility/PaymentEligibilitySeal.vue'
import type { PaymentEligibilityView } from '@/types/payment-eligibility.types'

const REPLACE_ACTION_TOOLTIP =
  'Substituir médico — trocar esta linha por outro médico da base (não é texto livre)'
const MARK_ABSENT_ACTION_TOOLTIP =
  'Não consta na folha — o médico previsto na escala não assinou esta folha'
const UNMARK_ABSENT_ACTION_TOOLTIP = 'Desfazer "não consta na folha"'

/** Aspas dentro do rótulo não cabem num atributo de template — daí a função. */
type TimeFieldKey = (typeof TIME_FIELDS)[number]['key']
type SignatureStampKey = (typeof TIME_FIELDS)[number]['checkKey']

const POPOVER_GAP = 4
const VIEWPORT_MARGIN = 8
/** Largura mínima das duas variantes (ver `.sheet-mirror-popover*` no style). */
const MENU_WIDTH = 190
const REPLACE_WIDTH = 320
/**
 * Alturas APROXIMADAS, usadas só para decidir se o popover abre para baixo ou
 * para cima. Errar por alguns pixels desloca a abertura; não recorta nada.
 */
const MENU_HEIGHT_ESTIMATE = 140
const REPLACE_HEIGHT_ESTIMATE = 340

const SELECTED_ROW_CLASS = 'outline outline-2 -outline-offset-2 outline-primary30 bg-primary5/30'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceSheetMirror',
  props: {
    rows: {},
    disabled: { type: Boolean },
    canAddRow: { type: Boolean },
    containerId: {},
    showSignatureStamp: { type: Boolean },
    currentPage: {},
    selectedIndex: {},
    eligibilityByDoctorStation: {}
  },
  emits: ["updateCell", "selectDoctor", "addRow", "removeRow", "markAbsent", "unmarkAbsent", "replaceDoctor", "undoConciliation", "jumpToPage", "markCurrentPage", "selectRow"],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * ESP-02/29-04 — a grade do "Espelho da Escala" (mockup 05, aprovado pelo usuário em
 * 03/09). Não é a grade de planilha (`AttendanceSheetCard`): aqui a linha não nasce vazia,
 * ela nasce da escala prevista, e o operador só toca no que a folha física contradiz.
 *
 * O componente é puramente apresentacional — decide zero sobre o domínio. Todo estado de
 * linha, contagem e candidato vem de `utils/prefill-mirror.ts`, e toda ação sobe por evento
 * para a tela, que é quem fala com a API.
 */




const TIME_FIELDS = [
  {
    key: 'checkin',
    previousKey: 'prefilledCheckin',
    label: 'Entrada',
    checkKey: 'hasDoctorSignature',
    checkLabel: 'Ass. e Carimbo Entrada'
  },
  {
    key: 'checkout',
    previousKey: 'prefilledCheckout',
    label: 'Saída',
    checkKey: 'hasDoctorStamp',
    checkLabel: 'Ass. e Carimbo Saída'
  }
] as const

/**
 * Textos das ações de linha. Eles dizem o que a ação faz E o que ela não é: "substituir" já
 * foi confundido com digitar outro nome, e "não consta" com "faltou ao plantão".
 */
function unmarkAbsentAriaLabel(index: number): string {
  return `${UNMARK_ABSENT_ACTION_TOOLTIP} na linha ${index + 1}`
}

const openMenuIndex = ref<number | null>(null)
const replaceIndex = ref<number | null>(null)
const replaceSearch = ref('')

/**
 * Retângulo do botão ⋯ que abriu o overlay, em coordenadas de viewport.
 *
 * Os popovers são `position: fixed` posicionados a partir daqui, e não
 * `absolute` dentro da célula: a grade vive num container `overflow-x-auto`
 * (necessário para a tabela larga em telas pequenas), e o CSS obriga
 * `overflow-y` a acompanhar o eixo x. Ancorado na célula, o popover era
 * recortado por esse container e mexia no scroll da grade em vez de flutuar
 * por cima. `fixed` não entra no fluxo nem é recortado por overflow de
 * ancestral — a tela é uma rota, sem modal/`transform` no caminho que pudesse
 * criar um containing block.
 */
const anchorRect = ref<DOMRect | null>(null)

function buildPopoverStyle(width: number, heightEstimate: number) {
  const rect = anchorRect.value
  if (!rect) return undefined

  /*
   * O popover cresce PARA DENTRO da tela: gatilho na metade esquerda alinha pela borda
   * esquerda, na metade direita pela direita. Alinhar sempre pela direita vinha do ⋯, que
   * mora na ponta da tabela; com "Substituir médico" promovido a ícone ao lado do nome, os
   * 320 px do popover eram empurrados contra a margem esquerda, longe da linha trocada.
   * O clamp final garante que ele não vaze por nenhum dos lados.
   */
  const maxLeft = Math.max(VIEWPORT_MARGIN, window.innerWidth - width - VIEWPORT_MARGIN)
  const anchorsLeft = rect.left + rect.width / 2 < window.innerWidth / 2
  const preferredLeft = anchorsLeft ? rect.left : rect.right - width
  const left = Math.min(Math.max(VIEWPORT_MARGIN, preferredLeft), maxLeft)

  const fitsBelow = window.innerHeight - rect.bottom >= heightEstimate + VIEWPORT_MARGIN
  const vertical = fitsBelow
    ? { top: `${rect.bottom + POPOVER_GAP}px` }
    : { bottom: `${window.innerHeight - rect.top + POPOVER_GAP}px` }

  return { position: 'fixed' as const, left: `${left}px`, ...vertical }
}

const menuStyle = computed(() => buildPopoverStyle(MENU_WIDTH, MENU_HEIGHT_ESTIMATE))
const replaceStyle = computed(() => buildPopoverStyle(REPLACE_WIDTH, REPLACE_HEIGHT_ESTIMATE))

const coverage = computed(() => prefillCoverage(props.rows))
const coverageLabel = computed(() => prefillCoverageLabel(coverage.value))

const replaceCandidates = computed(() => {
  const index = replaceIndex.value
  if (index === null) return []
  return buildReplacementCandidates(props.rows, props.rows[index], replaceSearch.value)
})

const legend = computed(() => {
  const tally = tallyOutcomes(props.rows)
  return (
    [
      { key: PrefillOutcome.CONFIRMED, chipClass: 'border-lightGray30 text-neutral50' },
      { key: PrefillOutcome.EDITED, chipClass: 'border-alert text-alert' },
      { key: PrefillOutcome.ABSENT, chipClass: 'border-negative text-negative' },
      { key: PrefillOutcome.EXTRA, chipClass: 'border-primary10 text-primary30' }
    ] as const
  )
    .filter((entry) => tally[entry.key] > 0)
    .map((entry) => ({
      key: entry.key,
      chipClass: entry.chipClass,
      count: tally[entry.key],
      label: PREFILL_OUTCOME_CHIP_LABELS[entry.key].toLowerCase()
    }))
})

function isAbsent(row: MirrorRow): boolean {
  return resolveRowState(row) === PrefillOutcome.ABSENT
}

/**
 * `entryId === null` é a definição de linha extra recém-adicionada que ainda não
 * existe no backend (ver `MirrorRow.entryId`): removê-la é só descartar estado
 * local. Depois de enviada a linha tem id e passa a ser assunto do backend.
 */
function isDiscardableExtra(row: MirrorRow): boolean {
  return row.entryId === null
}

/**
 * Com "Substituir médico" e "Não consta na folha" promovidas a ícones, o ⋯ só faz sentido
 * quando ainda resta algo dentro dele.
 */
function hasRowMenu(row: MirrorRow): boolean {
  return isAutomaticallyConciliated(row) || isDiscardableExtra(row)
}

/** Realce da linha selecionada (`sel` do mockup V1) — anel, não troca de fundo. */
const markCurrentPageTitle = computed(() =>
  isValidPage(props.currentPage)
    ? `Marcar esta linha como página ${props.currentPage} da folha`
    : 'Abra uma página da folha para poder marcá-la'
)

/** Página utilizável da linha — `null` quando ninguém marcou ainda. */
function pageOf(row: MirrorRow): number | null {
  return resolveRowPage(row)
}

/** Sem página, o texto tem de ensinar a saída: o ⌖ ao lado é quem marca. */
function pageCellTitle(row: MirrorRow): string {
  const page = pageOf(row)
  return page === null
    ? 'Linha sem página marcada — use ⌖ para marcar a página que o visualizador mostra'
    : `Ir para a página ${page} da folha`
}

function jumpToRowPage(row: MirrorRow): void {
  const page = pageOf(row)
  if (page !== null) emit('jumpToPage', page)
}

function rowClass(row: MirrorRow): string {
  const state = resolveRowState(row)
  // Ausente é um desfecho legítimo e reversível, não um erro: o chip vermelho
  // já comunica o estado, então a linha fica em cinza-claro em vez de vermelha.
  if (state === PrefillOutcome.ABSENT) return 'bg-lightGray30/40 border-b border-lightGray30'
  if (state === PrefillOutcome.EDITED) return 'bg-[#FDF1DF] border-b border-lightGray30'
  if (state === PrefillOutcome.EXTRA) return 'bg-primary5/40 border-b border-lightGray30'
  return 'border-b border-lightGray30'
}

function chipClass(row: MirrorRow): string {
  const state = resolveRowState(row)
  if (state === PrefillOutcome.ABSENT) return 'bg-white border-negative text-negative'
  if (state === PrefillOutcome.EDITED) return 'bg-white border-alert text-alert'
  if (state === PrefillOutcome.EXTRA) return 'bg-white border-primary10 text-primary30'
  if (state === PrefillOutcome.CONFIRMED) return 'bg-white border-sucess text-sucess'
  return 'bg-gray-100 border-lightGray30 text-neutral50'
}

function chipDotClass(row: MirrorRow): string {
  const state = resolveRowState(row)
  if (state === PrefillOutcome.ABSENT) return 'bg-negative'
  if (state === PrefillOutcome.EDITED) return 'bg-alert'
  if (state === PrefillOutcome.EXTRA) return 'bg-primary30'
  if (state === PrefillOutcome.CONFIRMED) return 'bg-sucess'
  return 'bg-neutralLight'
}

function timeInputClass(row: MirrorRow, field: TimeFieldKey): string {
  if (isAbsent(row)) return 'border-negative line-through text-negative bg-white'
  // Frente E/Q21 — obrigatório vazio vence o laranja de "editado": apagar o horário
  // pré-preenchido é o caso mais urgente da linha.
  if (isJourneyValueEmpty(row[field])) return JOURNEY_EMPTY_CLASSES
  return showPrevious(row, field)
    ? 'border-alert font-bold text-alert bg-white'
    : 'border-lightGray30 bg-white'
}

/** O riscado só aparece quando o valor atual difere do que o espelho escreveu. */
function showPrevious(row: MirrorRow, field: TimeFieldKey): boolean {
  const previous = field === 'checkin' ? row.prefilledCheckin : row.prefilledCheckout
  return Boolean(row.isPrefillBorn && previous) && row[field] !== previous
}

/**
 * Seleção de linha por clique, mas NÃO a partir de um campo: `selectRow` faz o visualizador
 * pular para a página da linha, e a folha saltar debaixo de quem acabou de clicar no input
 * para digitar é desorientador. Quem entra pelo teclado (`Tab`) continua selecionando, pelo
 * `@focusin` da linha — o realce tem de acompanhar o cursor.
 */
const INTERACTIVE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON', 'A', 'OPTION']

function handleRowClick(index: number, event: MouseEvent) {
  const target = event.target as HTMLElement | null
  if (target?.isContentEditable) return
  if (target?.tagName && INTERACTIVE_TAGS.includes(target.tagName)) return
  emit('selectRow', index)
}

function emitCell(index: number, field: keyof MirrorRow, event: Event) {
  const value = (event.target as HTMLInputElement).value
  emit('updateCell', { index, field, value })
}

function emitCheck(index: number, field: SignatureStampKey, event: Event) {
  emit('updateCell', { index, field, value: (event.target as HTMLInputElement).checked })
}

/** Caixa desmarcada numa linha em uso é o que trava o avanço: destaque de atenção. */
function signatureStampClass(row: MirrorRow, field: SignatureStampKey): string {
  if (isAbsent(row)) return 'opacity-40'
  return row[field] ? 'accent-primary30' : 'outline outline-2 outline-alert'
}

/** O `DoctorSuggestionCell` já entrega o valor pronto, sem passar pelo evento. */
function emitCellValue(index: number, field: keyof MirrorRow, value: string) {
  emit('updateCell', { index, field, value })
}

function selectSuggestion(index: number, suggestion: DSAttendanceDoctorSuggestion) {
  emit('selectDoctor', {
    index,
    doctorName: suggestion.name,
    crm: formatCrm(suggestion)
  })
}

function closeOverlays() {
  openMenuIndex.value = null
  replaceIndex.value = null
  replaceSearch.value = ''
  anchorRect.value = null
}

function toggleMenu(index: number, event?: MouseEvent) {
  replaceIndex.value = null
  const willOpen = openMenuIndex.value !== index
  openMenuIndex.value = willOpen ? index : null

  const trigger = event?.currentTarget as HTMLElement | undefined
  anchorRect.value = willOpen && trigger ? trigger.getBoundingClientRect() : null
}

/**
 * O popover de substituição é `fixed` e se posiciona a partir de `anchorRect`. Agora que ele
 * abre pelo ícone da linha (e não mais pelo ⋯), é esse botão que precisa ancorá-lo — sem o
 * retângulo o popover voltaria a nascer no canto, longe da linha que está sendo trocada.
 */
function openReplace(index: number, event?: MouseEvent) {
  openMenuIndex.value = null
  replaceSearch.value = ''
  replaceIndex.value = index

  const trigger = event?.currentTarget as HTMLElement | undefined
  if (trigger) anchorRect.value = trigger.getBoundingClientRect()
}

function markAbsent(index: number) {
  openMenuIndex.value = null
  emit('markAbsent', index)
}

function unmarkAbsent(index: number) {
  closeOverlays()
  emit('unmarkAbsent', index)
}

function removeRow(index: number) {
  closeOverlays()
  emit('removeRow', index)
}

/** BUG UI-8 — ecoa o `entryId` da linha, o mesmo que `confirm-conciliation` já espera. */
function undoConciliation(index: number) {
  const row = props.rows[index]
  if (row.entryId === null) return
  openMenuIndex.value = null
  emit('undoConciliation', row.entryId)
}

function confirmReplace(index: number, doctorStationId: number) {
  emit('replaceDoctor', { index, doctorStationId })
  closeOverlays()
}

/**
 * Fechar por clique-fora escuta `mousedown`, que chega ANTES do `click` — e `@click.stop`
 * nos itens não segura `mousedown` nenhum. Sem esta guarda o popover fechava no aperto do
 * botão e o `click` do item nunca era entregue: "Substituir médico" e "Não consta na folha"
 * ficavam inertes ao mouse real (só respondiam a `click` sintético, o que fez os testes
 * antigos passarem). Um mousedown nascido DENTRO de um popover não é clique-fora.
 */
function handleOutsideClick(event: MouseEvent) {
  const target = event.target as Element | null
  if (target?.closest?.('.sheet-mirror-popover')) return
  closeOverlays()
}

function handleEscKey(event: KeyboardEvent) {
  if (event.key === 'Escape') closeOverlays()
}

const hasOverlay = computed(() => openMenuIndex.value !== null || replaceIndex.value !== null)

/**
 * Um popover `fixed` fica preso à viewport e não acompanha a linha que o
 * ancorou. Rolar ou redimensionar fecha — comportamento padrão de menu curto e
 * honesto com o usuário, em vez de deixar o popover órfão longe da linha.
 * `capture: true` para pegar também o scroll do container da grade, que não
 * borbulha até o `document`.
 */
function detachOverlayListeners() {
  document.removeEventListener('mousedown', handleOutsideClick)
  document.removeEventListener('keydown', handleEscKey)
  document.removeEventListener('scroll', closeOverlays, true)
  window.removeEventListener('resize', closeOverlays)
}

watch(hasOverlay, (open) => {
  if (open) {
    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('keydown', handleEscKey)
    document.addEventListener('scroll', closeOverlays, true)
    window.addEventListener('resize', closeOverlays)
  } else {
    detachOverlayListeners()
  }
})

/**
 * Frente E/Q21 — digitação guiada da jornada. Ao abrir o espelho, o foco vai para o
 * primeiro horário vazio; linha nova abre no primeiro campo vazio DELA (o nome, na extra);
 * Tab num horário pula para o próximo horário vazio. Só no mount e em linha nova: refocar
 * a cada fim de requisição (`disabled` volta a `false` depois de todo salvamento) tiraria
 * o cursor de quem está digitando. Efeito colateral aceito: cada `<tr>` emite `selectRow`
 * no `focusin`, então o foco automático também seleciona a linha e pagina o visualizador.
 */
const mirrorRootRef = ref<HTMLElement | null>(null)

function onMirrorKeydown(event: KeyboardEvent) {
  handleJourneyTab(event, mirrorRootRef.value)
}

onMounted(() => {
  void nextTick(() => focusFirstEmptyJourneyField(mirrorRootRef.value))
})

watch(
  () => props.rows.length,
  (length, previous) => {
    if (length <= previous) return
    // Só a linha extra recém-adicionada abre no próprio primeiro campo vazio (o nome);
    // mais linhas por outro motivo (ex.: novo prefill) seguem a regra da abertura.
    const lastRow = props.rows[length - 1]
    void nextTick(() => {
      if (!lastRow || !isDiscardableExtra(lastRow)) {
        focusFirstEmptyJourneyField(mirrorRootRef.value)
        return
      }
      const newRow = mirrorRootRef.value?.querySelector(
        `[data-testid="sheet-mirror-row-${length - 1}"]`
      )
      focusFirstEmptyInput(newRow)
    })
  }
)

onBeforeUnmount(detachOverlayListeners)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mirrorRootRef",
    ref: mirrorRootRef,
    class: "w-full",
    "data-testid": "sheet-mirror",
    onKeydown: onMirrorKeydown
  }, [
    (coverage.value.total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", {
              class: "block h-full rounded-full bg-primary30",
              style: _normalizeStyle({ width: `${coverage.value.percentage}%` })
            }, null, 4)
          ]),
          _createElementVNode("span", null, _toDisplayString(coverageLabel.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TIME_FIELDS, (field) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: field.key
              }, [
                _createElementVNode("th", _hoisted_12, _toDisplayString(field.label), 1),
                (_ctx.showSignatureStamp)
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 0,
                      class: "py-2 px-2 w-24 font-bold text-center",
                      "data-testid": `sheet-mirror-${field.checkKey}-header`
                    }, _toDisplayString(field.checkLabel), 9, _hoisted_13))
                  : _createCommentVNode("", true)
              ], 64))
            }), 64)),
            _hoisted_14,
            _hoisted_15
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.entryId ?? `extra-${index}`,
              "data-testid": `sheet-mirror-row-${index}`,
              class: _normalizeClass([rowClass(row), _ctx.selectedIndex === index ? SELECTED_ROW_CLASS : '']),
              onClick: ($event: any) => (handleRowClick(index, $event)),
              onFocusin: ($event: any) => (emit('selectRow', index))
            }, [
              _createElementVNode("td", _hoisted_17, _toDisplayString(index + 1), 1),
              _createElementVNode("td", {
                class: "py-1.5 px-2 align-middle font-mono text-xs text-neutral50",
                "data-testid": `sheet-mirror-station-id-${index}`
              }, [
                _createTextVNode(_toDisplayString(row.doctorStationId ?? '—') + " ", 1),
                (
                  row.doctorStationId !== null && _ctx.eligibilityByDoctorStation?.[row.doctorStationId]
                )
                  ? (_openBlock(), _createBlock(PaymentEligibilitySeal, {
                      key: 0,
                      class: "mt-1",
                      compact: "",
                      eligibility: _ctx.eligibilityByDoctorStation?.[row.doctorStationId] ?? null,
                      "test-id": `sheet-mirror-eligibility-${index}`
                    }, null, 8, ["eligibility", "test-id"]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_18),
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-bold whitespace-nowrap", chipClass(row)]),
                  "data-testid": `sheet-mirror-state-${index}`
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["h-1.5 w-1.5 rounded-full", chipDotClass(row)])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_unref(rowStateChipLabel)(_unref(resolveRowState)(row))), 1)
                ], 10, _hoisted_20)
              ]),
              _createElementVNode("td", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (row.entryId !== null)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        text: REPLACE_ACTION_TOOLTIP,
                        location: "top"
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createElementVNode("button", _mergeProps(tooltipProps, {
                            type: "button",
                            class: "h-6 w-6 rounded flex items-center justify-center text-primary30 hover:bg-primary5 disabled:opacity-40",
                            title: REPLACE_ACTION_TOOLTIP,
                            "aria-label": `Substituir médico da linha ${index + 1}`,
                            disabled: _ctx.disabled,
                            "data-testid": `sheet-mirror-replace-${index}`,
                            onClick: _withModifiers(($event: any) => (openReplace(index, $event)), ["stop"])
                          }), [
                            _createVNode(_component_v_icon, {
                              icon: _unref(mdiAccountSwitchOutline),
                              size: "16"
                            }, null, 8, ["icon"])
                          ], 16, _hoisted_23)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (row.entryId !== null && !isAbsent(row))
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 1,
                        text: MARK_ABSENT_ACTION_TOOLTIP,
                        location: "top"
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createElementVNode("button", _mergeProps(tooltipProps, {
                            type: "button",
                            class: "h-6 w-6 rounded flex items-center justify-center text-negative hover:bg-negative/10 disabled:opacity-40",
                            title: MARK_ABSENT_ACTION_TOOLTIP,
                            "aria-label": `Marcar a linha ${index + 1} como não constante na folha`,
                            disabled: _ctx.disabled,
                            "data-testid": `sheet-mirror-mark-absent-${index}`,
                            onClick: _withModifiers(($event: any) => (markAbsent(index)), ["stop"])
                          }), [
                            _createVNode(_component_v_icon, {
                              icon: _unref(mdiAccountOffOutline),
                              size: "16"
                            }, null, 8, ["icon"])
                          ], 16, _hoisted_24)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (isAbsent(row))
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 2,
                        text: UNMARK_ABSENT_ACTION_TOOLTIP,
                        location: "top"
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createElementVNode("button", _mergeProps(tooltipProps, {
                            type: "button",
                            class: "h-6 w-6 rounded flex items-center justify-center text-neutral50 hover:bg-primary5 disabled:opacity-40",
                            title: UNMARK_ABSENT_ACTION_TOOLTIP,
                            "aria-label": unmarkAbsentAriaLabel(index),
                            disabled: _ctx.disabled,
                            "data-testid": `sheet-mirror-unmark-absent-${index}`,
                            onClick: _withModifiers(($event: any) => (unmarkAbsent(index)), ["stop"])
                          }), [
                            _createVNode(_component_v_icon, {
                              icon: _unref(mdiUndoVariant),
                              size: "16"
                            }, null, 8, ["icon"])
                          ], 16, _hoisted_25)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("td", _hoisted_26, [
                (row.isPrefillBorn)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "block max-w-[220px] truncate font-semibold",
                      title: row.doctorName || undefined,
                      "data-testid": `sheet-mirror-doctor-${index}`
                    }, _toDisplayString(row.doctorName || '—'), 9, _hoisted_27))
                  : (_ctx.containerId)
                    ? (_openBlock(), _createBlock(DoctorSuggestionCell, {
                        key: 1,
                        "model-value": row.doctorName,
                        "container-id": _ctx.containerId,
                        field: "name",
                        "column-key": "rawDoctorName",
                        "row-index": index,
                        "onUpdate:modelValue": ($event: any) => (emitCellValue(index, 'doctorName', $event)),
                        onSelect: ($event: any) => (selectSuggestion(index, $event))
                      }, null, 8, ["model-value", "container-id", "row-index", "onUpdate:modelValue", "onSelect"]))
                    : (_openBlock(), _createElementBlock("input", {
                        key: 2,
                        type: "text",
                        class: "w-full rounded border border-lightGray30 px-2 py-1 text-sm",
                        placeholder: "Nome do médico",
                        value: row.doctorName,
                        "data-testid": `sheet-mirror-doctor-input-${index}`,
                        onInput: ($event: any) => (emitCell(index, 'doctorName', $event))
                      }, null, 40, _hoisted_28))
              ]),
              _createElementVNode("td", _hoisted_29, [
                (row.isPrefillBorn)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "font-mono text-xs",
                      "data-testid": `sheet-mirror-crm-${index}`
                    }, _toDisplayString(row.crm || '—'), 9, _hoisted_30))
                  : (_ctx.containerId)
                    ? (_openBlock(), _createBlock(DoctorSuggestionCell, {
                        key: 1,
                        "model-value": row.crm,
                        "container-id": _ctx.containerId,
                        field: "crm",
                        "column-key": "rawCrm",
                        "row-index": index,
                        "onUpdate:modelValue": ($event: any) => (emitCellValue(index, 'crm', $event)),
                        onSelect: ($event: any) => (selectSuggestion(index, $event))
                      }, null, 8, ["model-value", "container-id", "row-index", "onUpdate:modelValue", "onSelect"]))
                    : (_openBlock(), _createElementBlock("input", {
                        key: 2,
                        type: "text",
                        class: "w-full rounded border border-lightGray30 px-2 py-1 text-sm font-mono",
                        placeholder: "CRM",
                        value: row.crm,
                        "data-testid": `sheet-mirror-crm-input-${index}`,
                        onInput: ($event: any) => (emitCell(index, 'crm', $event))
                      }, null, 40, _hoisted_31))
              ]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TIME_FIELDS, (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: field.key
                }, [
                  _createElementVNode("td", _hoisted_32, [
                    _createElementVNode("input", _mergeProps({
                      type: "time",
                      class: ["w-full rounded border px-2 py-1 text-sm font-mono", timeInputClass(row, field.key)],
                      value: row[field.key],
                      disabled: _ctx.disabled || isAbsent(row),
                      "aria-label": `${field.label} da linha ${index + 1}`
                    }, _unref(journeyFieldAttrs)(!isAbsent(row)), {
                      "data-testid": `sheet-mirror-${field.key}-${index}`,
                      onChange: ($event: any) => (emitCell(index, field.key, $event))
                    }), null, 16, _hoisted_33),
                    (showPrevious(row, field.key))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "block mt-0.5 text-[10px] text-neutral50 font-mono",
                          "data-testid": `sheet-mirror-${field.key}-previous-${index}`
                        }, [
                          _createTextVNode(" antes: "),
                          _createElementVNode("s", null, _toDisplayString(row[field.previousKey]), 1)
                        ], 8, _hoisted_34))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.showSignatureStamp)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: _normalizeClass(["h-4 w-4 rounded align-middle", signatureStampClass(row, field.checkKey)]),
                          checked: row[field.checkKey],
                          disabled: _ctx.disabled || isAbsent(row),
                          "aria-label": `${field.checkLabel} da linha ${index + 1}`,
                          "data-testid": `sheet-mirror-${field.checkKey}-${index}`,
                          onChange: ($event: any) => (emitCheck(index, field.checkKey, $event))
                        }, null, 42, _hoisted_36)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 64)),
              _createElementVNode("td", _hoisted_37, [
                _createVNode(_component_v_tooltip, {
                  text: pageCellTitle(row),
                  location: "top"
                }, {
                  activator: _withCtx(({ props: tooltipProps }) => [
                    _createElementVNode("button", _mergeProps(tooltipProps, {
                      type: "button",
                      class: ["h-6 min-w-6 rounded px-1.5 text-xs font-mono font-bold leading-none", 
                      pageOf(row) === null
                        ? 'text-neutral50'
                        : 'text-primary30 underline hover:bg-primary5'
                    ],
                      disabled: pageOf(row) === null,
                      title: pageCellTitle(row),
                      "aria-label": 
                      pageOf(row) === null
                        ? `Linha ${index + 1} sem página marcada`
                        : `Ir para a página ${pageOf(row)} da folha`
                    ,
                      "data-testid": `sheet-mirror-page-${index}`,
                      onClick: _withModifiers(($event: any) => (jumpToRowPage(row)), ["stop"])
                    }), _toDisplayString(_unref(formatPageCell)(row.pageNumber)), 17, _hoisted_38)
                  ]),
                  _: 2
                }, 1032, ["text"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ml-1 h-6 w-6 rounded text-[13px] leading-none text-neutral50 hover:bg-primary5 disabled:opacity-40",
                  disabled: _ctx.disabled || !_unref(isValidPage)(_ctx.currentPage) || pageOf(row) === _ctx.currentPage,
                  title: markCurrentPageTitle.value,
                  "aria-label": `Marcar a página atual na linha ${index + 1}`,
                  "data-testid": `sheet-mirror-mark-page-${index}`,
                  onClick: _withModifiers(($event: any) => (emit('markCurrentPage', index)), ["stop"])
                }, " ⌖ ", 8, _hoisted_39)
              ]),
              _createElementVNode("td", _hoisted_40, [
                (hasRowMenu(row))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "h-6 w-6 rounded text-neutral50 font-bold leading-none hover:bg-primary5",
                      "aria-label": `Mais ações da linha ${index + 1}`,
                      "aria-expanded": openMenuIndex.value === index,
                      "data-testid": `sheet-mirror-menu-button-${index}`,
                      disabled: _ctx.disabled,
                      onClick: _withModifiers(($event: any) => (toggleMenu(index, $event)), ["stop"])
                    }, " ⋯ ", 8, _hoisted_41))
                  : (_openBlock(), _createElementBlock("span", _hoisted_42)),
                (openMenuIndex.value === index)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "sheet-mirror-popover",
                      role: "menu",
                      style: _normalizeStyle(menuStyle.value),
                      "data-testid": `sheet-mirror-menu-${index}`
                    }, [
                      (_unref(isAutomaticallyConciliated)(row))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            role: "menuitem",
                            class: "sheet-mirror-menu-item",
                            "data-testid": `sheet-mirror-undo-conciliation-${row.entryId}`,
                            onClick: _withModifiers(($event: any) => (undoConciliation(index)), ["stop"])
                          }, " Desfazer conciliação ", 8, _hoisted_44))
                        : _createCommentVNode("", true),
                      (isDiscardableExtra(row))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            role: "menuitem",
                            class: "sheet-mirror-menu-item text-negative",
                            "data-testid": `sheet-mirror-remove-row-${index}`,
                            onClick: _withModifiers(($event: any) => (removeRow(index)), ["stop"])
                          }, " Remover linha ", 8, _hoisted_45))
                        : _createCommentVNode("", true)
                    ], 12, _hoisted_43))
                  : _createCommentVNode("", true),
                (replaceIndex.value === index)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "sheet-mirror-popover sheet-mirror-popover-wide",
                      style: _normalizeStyle(replaceStyle.value),
                      "data-testid": `sheet-mirror-replace-popover-${index}`
                    }, [
                      _createElementVNode("p", _hoisted_47, " Substituir médico — linha " + _toDisplayString(index + 1), 1),
                      _createElementVNode("p", _hoisted_48, _toDisplayString(row.doctorName) + " · " + _toDisplayString(row.crm), 1),
                      _createElementVNode("div", _hoisted_49, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((replaceSearch).value = $event)),
                          type: "text",
                          class: "w-full rounded border border-primary30 px-2 py-1 text-sm",
                          placeholder: "Buscar por nome ou CRM",
                          "data-testid": `sheet-mirror-replace-search-${index}`
                        }, null, 8, _hoisted_50), [
                          [_vModelText, replaceSearch.value]
                        ])
                      ]),
                      _createElementVNode("ul", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replaceCandidates.value, (candidate) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: candidate.doctorStationId
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "w-full flex items-center gap-2 rounded border border-lightGray30 px-2 py-1.5 mb-1 text-left hover:bg-primary5",
                              "data-testid": `sheet-mirror-candidate-${candidate.doctorStationId}`,
                              onClick: _withModifiers(($event: any) => (confirmReplace(index, candidate.doctorStationId)), ["stop"])
                            }, [
                              _createElementVNode("span", _hoisted_53, [
                                _createElementVNode("span", _hoisted_54, _toDisplayString(candidate.name), 1),
                                _createElementVNode("span", _hoisted_55, _toDisplayString(candidate.crm), 1)
                              ]),
                              (candidate.isSuggested)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "rounded-full border border-sucess px-2 py-0.5 text-[9px] font-bold text-sucess",
                                    "data-testid": `sheet-mirror-candidate-suggested-${candidate.doctorStationId}`
                                  }, "Sugerido", 8, _hoisted_56))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_52)
                          ]))
                        }), 128)),
                        (replaceCandidates.value.length === 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_57, " Nenhum profissional escalado neste turno corresponde à busca. "))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_58
                    ], 12, _hoisted_46))
                  : _createCommentVNode("", true)
              ])
            ], 42, _hoisted_16))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createVNode(OutlineButton, {
        text: "Adicionar linha",
        width: "150px",
        height: "36px",
        "data-testid": "sheet-mirror-add-row",
        disabled: _ctx.disabled || !_ctx.canAddRow,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('addRow')))
      }, null, 8, ["disabled"]),
      _createElementVNode("div", _hoisted_60, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(legend.value, (entry) => {
          return (_openBlock(), _createElementBlock("span", {
            key: entry.label,
            class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 font-bold", entry.chipClass]),
            "data-testid": `sheet-mirror-legend-${entry.key}`
          }, _toDisplayString(entry.count) + " " + _toDisplayString(entry.label), 11, _hoisted_61))
        }), 128))
      ])
    ])
  ], 544))
}
}

})